import PropTypes from 'prop-types';

const PNR_MAX_LENGTH = 6;
const TICKET_NO_MAX_LENGTH = 14;

export default function PassengerDetailsCard({ classPrefix, partner, details, showErrors }) {
  const p = classPrefix;
  const {
    values, setPnr, setTicketNo,
    isPnrValid, isTicketNoValid,
  } = details;

  const pnrTouched = Boolean(values.pnr);
  const ticketTouched = Boolean(values.ticketNo);
  const pnrError = (pnrTouched && !isPnrValid) || (showErrors && !isPnrValid);
  const ticketError = (ticketTouched && !isTicketNoValid) || (showErrors && !isTicketNoValid);

  return (
    <>
      <div className={`${p}-card`}>
        <div className={`${p}-ch`}>
          <div className={`${p}-ci`}>🏨</div>
          <span className={`${p}-ct`}>Hotel Details</span>
        </div>
        <div className={`${p}-field-ro`}>
          <span className={`${p}-field-lbl`}>Hotel Name</span>
          <span className={`${p}-field-val`}>{partner.hotel_name || partner.name}</span>
        </div>
      </div>

      <div className={`${p}-card`}>
        <div className={`${p}-ch`}>
          <div className={`${p}-ci`}>👤</div>
          <span className={`${p}-ct`}>Passenger Details</span>
          <span className={`${p}-req-badge`}>Required</span>
        </div>
        <div className={`${p}-field-group`}>
          <label className={`${p}-label${pnrError ? ` ${p}-label-err` : ''}`} htmlFor={`${p}-pnr`}>
            PNR Number <span className={`${p}-req`}>*</span>
          </label>
          <input id={`${p}-pnr`} className={`${p}-input${pnrError ? ' input-error' : ''}`} type="text"
            placeholder="Enter PNR number" maxLength={PNR_MAX_LENGTH}
            value={values.pnr} onChange={e => setPnr(e.target.value)} />
          {values.pnr && !isPnrValid && (
            <span className={`${p}-field-hint field-hint-err`}>PNR must be exactly {PNR_MAX_LENGTH} characters ({values.pnr.trim().length}/{PNR_MAX_LENGTH})</span>
          )}
          {showErrors && !values.pnr && (
            <span className={`${p}-field-err-msg`}>PNR Number is required</span>
          )}
        </div>
        <div className={`${p}-field-group`}>
          <label className={`${p}-label${ticketError ? ` ${p}-label-err` : ''}`} htmlFor={`${p}-ticket`}>
            Ticket No <span className={`${p}-req`}>*</span>
          </label>
          <input id={`${p}-ticket`} className={`${p}-input${ticketError ? ' input-error' : ''}`} type="text"
            placeholder="Enter ticket number" maxLength={TICKET_NO_MAX_LENGTH}
            value={values.ticketNo} onChange={e => setTicketNo(e.target.value.replace(/[^A-Za-z0-9]/g, ''))} />
          {values.ticketNo && !isTicketNoValid && (
            <span className={`${p}-field-hint field-hint-err`}>Ticket No must be 10–14 letters/numbers, no special characters ({values.ticketNo.trim().length}/{TICKET_NO_MAX_LENGTH})</span>
          )}
          {showErrors && !values.ticketNo && (
            <span className={`${p}-field-err-msg`}>Ticket No is required</span>
          )}
        </div>
      </div>
    </>
  );
}

PassengerDetailsCard.propTypes = {
  classPrefix: PropTypes.string.isRequired,
  partner: PropTypes.shape({
    name: PropTypes.string,
    hotel_name: PropTypes.string,
  }).isRequired,
  details: PropTypes.shape({
    values: PropTypes.shape({
      pnr: PropTypes.string.isRequired,
      ticketNo: PropTypes.string.isRequired,
    }).isRequired,
    setPnr: PropTypes.func.isRequired,
    setTicketNo: PropTypes.func.isRequired,
    isPnrValid: PropTypes.bool.isRequired,
    isTicketNoValid: PropTypes.bool.isRequired,
  }).isRequired,
  showErrors: PropTypes.bool,
};

PassengerDetailsCard.defaultProps = {
  showErrors: false,
};
